<template>
  <div class="mt-4">
    <section-title content="ll. Método de Evaluación" :has-line="true" />
    <div class="row mb-4">
      <!-- Single column for small screens and two columns for larger screens -->
      <div
        class="col-12 col-md-6 mb-4"
        v-for="(method, key) in evaluationMethodsToDisplay"
        :key="key"
      >
        <div class="custom-control custom-checkbox">
          <checkbox
            class="my-2"
            :disabled-bg-color="'bg-dark-gray'"
            :checked-bg-color="'bg-success'"
            :icon="'fal fa-check'"
            v-model="method.checked"
            :text="method.name"
            :id="method.id"
            :disabled="method.disabled || isReadOnly"
            @input="
              (data) => checkChanged(data, method.id, method.evaluationMethodId)
            "
          />
        </div>
      </div>
      <div class="col-12">
        <validation-provider
          v-slot="{ errors }"
          :rules="selectedEvaluationMethods.length == 0 ? 'required' : ''"
        >
          <error
            v-if="errors[0]"
            :message="'Favor seleccionar al menos una opción.'"
            variant="no-border"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import referralService from '@/services/api/referralsandequipments.api';
import Checkbox from 'CheckBox';
import Error from 'custom-error';
export default {
  components: {
    SectionTitle,
    Checkbox,
    Error,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    evaluationMethods: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      evaluationMethodsToDisplay: [],
      selectedEvaluationMethods: [],
    };
  },
  watch: {
    evaluationMethods: {
      immediate: true,
      handler(value, oldValue) {
        this.getEvaluation().then(() => {
          this.evaluationMethodsToDisplay = this.evaluationMethodsToDisplay.map(
            (x) => ({
              ...x,
              checked:
                value.filter((t) => t.evaluationMethodId == x.id).length > 0 ||
                x.selected,
              disabled: x.disabled,
            })
          );
        });
      },
    },
  },
  methods: {
    checkChanged(e, id, evaluationMethodId) {
      var checked = e;
      if (checked) {
        this.selectedEvaluationMethods.push({
          id: id,
          evaluationMethodId: evaluationMethodId,
        });
      } else {
        this.selectedEvaluationMethods = this.selectedEvaluationMethods.filter(
          (x) => x.id !== id
        );
      }
      this.modelChanged();
    },
    async getEvaluation() {
      const { data } = await referralService.getEvaluationInfo(this.referralId);
      this.evaluationMethodsToDisplay = data;
    },
    modelChanged() {
      this.$emit('input', this.selectedEvaluationMethods);
    },
  },
};
</script>

<style scoped></style>
